const PanelContent = {
  baseStyle: {
    ms: "auto",
    me: "auto",
    ps: "5px",
    pe: "5px",
  },
};

export const PanelContentComponent = {
  components: {
    PanelContent,
  },
};
